import { render, staticRenderFns } from "./DelayNoticePop.vue?vue&type=template&id=53b1bc7a"
import script from "./DelayNoticePop.vue?vue&type=script&lang=js"
export * from "./DelayNoticePop.vue?vue&type=script&lang=js"
import style0 from "./DelayNoticePop.vue?vue&type=style&index=0&id=53b1bc7a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b1bc7a')) {
      api.createRecord('53b1bc7a', component.options)
    } else {
      api.reload('53b1bc7a', component.options)
    }
    module.hot.accept("./DelayNoticePop.vue?vue&type=template&id=53b1bc7a", function () {
      api.rerender('53b1bc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/DelayNoticePop.vue"
export default component.exports